import React, { FC, memo } from 'react'

import {
  CalendarEventList as BaseCalendarEventList,
  CalendarEventProps,
} from '@factorialco/f0-react/dist/experimental'
import { compact, orderBy } from 'lodash'

import { Item, normalizeItem } from './helpers'

type Props = {
  items: Item[]
}

const itemTime = (item: CalendarEventProps) => {
  const date = item.fromDate ?? item.toDate
  if (date) {
    return date.getTime()
  }
  return 0
}

const CalendarEventList: FC<Props> = ({ items }) => {
  const normalizedItems = compact(items.map(normalizeItem))
  const sortedItems = orderBy(normalizedItems, [itemTime, 'title'], ['asc', 'asc'])

  return <BaseCalendarEventList events={sortedItems} />
}

export default memo(CalendarEventList)
